import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@ublique/components/LoadingModal'
import { handleRoleFields } from 'pages/Administration/Tabs/Roles/helpers'
import { sendNotification } from 'pages/Administration/helpers'
import Loading from '@ublique/components/Loading'
import 'pages/Administration/components/index.scss'

import {
  createRole,
  updateRole
} from 'services/api/administration/rolesUsersService'
import DefaultForm from '../DefaultForm'

const RoleModal = ({ open, close, data }) => {
  const { onCancel, modalType, roleValue, roles, gridApi } = data

  const { t } = useTranslation('Administration', 'Common')
  const [isRoleInvalid, setIsRoleInvalid] = useState(false)
  const defaultRole = { description: '', roleName: '' }
  const [value, setValue] = useState(roleValue || defaultRole)
  const [isLoading, setIsLoading] = useState(false)

  const handleOnAddChange = useCallback(
    (value) => {
      setValue((prevState) => ({ ...prevState, ...value }))
      processRoleValidation(value)
    },
    [value]
  )

  const processRoleValidation = ({ roleName }) => {
    roleName !== undefined && setIsRoleInvalid(roleName === '')
    return roleName === ''
  }

  const onAddRoleSubmit = async () => {
    if (modalType === 'AddRole' && processRoleValidation(value)) return

    function getPayload() {
      const payload = {
        roleName: value.roleName.trim(),
        useOwnership: false,
        description: value.description.trim()
      }
      return payload
    }

    const payload = getPayload()
    setIsLoading(true)

    if (
      modalType === 'AddRole' &&
      roles.filter((r) => r.roleName === payload.roleName).length !== 0
    ) {
      sendNotification({
        t,
        info: 'AddDuplicate',
        kind: 'error'
      })
    } else {
      try {
        modalType === 'AddRole'
          ? await createRole(payload)
          : await updateRole(payload, value.id)

        sendNotification({
          t,
          info: modalType === 'AddRole' ? 'Add' : 'Update',
          kind: 'success'
        })

        gridApi?.deselectAll()
      } catch (err) {
        console.error(err)
      }
    }
    close()
    setIsLoading(false)
  }

  return (
    <Modal
      open={open}
      hasScrollingContent={false}
      modalHeading={t(`RolesManagement.${modalType}`)}
      onRequestClose={close}
      onRequestSubmit={onAddRoleSubmit}
      onSecondarySubmit={onCancel}
      primaryButtonText={t(`Common:Save`)}
      primaryButtonDisabled={isRoleInvalid}
      secondaryButtonText={t(`Common:Cancel`)}
      selectorPrimaryFocus='[data-modal-primary-focus]'
      preventCloseOnClickOutside
      className='admin-view'
      // size='sm'
    >
        {isLoading && <Loading />}
        <DefaultForm
          permissionType='roles'
          formFields={handleRoleFields(
            handleOnAddChange,
            value,
            modalType,
            isRoleInvalid
          )}
          t={t}
        />
    </Modal>
  )
}

export default RoleModal
